import React from "react";
import { defaultPublicOutletContextState, IPublicOutletContextState } from "./PublicOutletContext.types";



export const PublicOutletContext = React.createContext<IPublicOutletContextState>(defaultPublicOutletContextState);